import { Component } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import { globalRouterTransition } from './router.animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [globalRouterTransition()]
})
export class AppComponent {
  loading = true;
  title = 'asset-database';
  oldRoute = '/';

  constructor(private router: Router, private route: ActivatedRoute) {
    router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
  }

  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }

  animationData() {
    // if (this.route.firstChild().children.length === 0) { // only level 0 routes
    const r = this.route.root.firstChild;
    if (r != null) {
      if (r.children.length === 0) { // only level 0 routes
        this.oldRoute = this.router.url;
        // console.log(this.oldRoute);
      }
    }
    const val = {
      value: this.oldRoute, // this.router.url,
      params: {}
    };
    // console.log(val);
    return val;
  }
}
